module.exports = __webpack_public_path__ + "static/media/filter.ff3ebc29.svg";